import { Separator } from "@/components/ui/separator";
import { Linkedin, Facebook, ArrowUp } from "lucide-react";

const footerLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Get a Quote", href: "#inquiry" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#141210] py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="text-center md:text-left">
            <button
              onClick={() => scrollTo("#home")}
              data-testid="footer-logo"
              className="group"
            >
              <span
                className="text-xl font-bold text-[#8D5A34] tracking-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Raihan
              </span>
              <span
                className="text-xl font-light text-white/60 tracking-tight ml-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                International
              </span>
            </button>
            <p
              className="text-white/30 text-xs mt-1"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Premium Leather & Agro Exports
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6" data-testid="footer-links">
            {footerLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-white/40 text-sm hover:text-[#D4AF37] transition-colors"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Social + back to top */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/raihaninternational/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-linkedin"
              className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-[#D4AF37] hover:border-[#D4AF37]/30 transition-all"
            >
              <Linkedin size={15} strokeWidth={1.5} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61577806037880"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-facebook"
              className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-[#D4AF37] hover:border-[#D4AF37]/30 transition-all"
            >
              <Facebook size={15} strokeWidth={1.5} />
            </a>
            <button
              onClick={() => scrollTo("#home")}
              data-testid="footer-back-to-top"
              className="w-9 h-9 rounded-full bg-[#8D5A34] flex items-center justify-center text-white hover:bg-[#5D3A20] transition-all ml-2"
            >
              <ArrowUp size={15} strokeWidth={2} />
            </button>
          </div>
        </div>

        <Separator className="my-8 bg-white/5" />

        <p
          className="text-center text-white/25 text-xs"
          data-testid="footer-copyright"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          &copy; {new Date().getFullYear()} Raihan International. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
